module.exports = __webpack_public_path__ + "static/media/trombone.d182d21d.jpg";